import api from "@/services/vex/api";

async function getGruposDoUsuario(idUsuario, token) {
    const uri = `/usuarios/v1/usuario/${token}/${idUsuario}/grupos`;

    return (await api.get(uri)).data;
}

export default getGruposDoUsuario;
